import React from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiCheck, FiDownload, FiZap } = FiIcons

const Hero = ({ onGenerateClick }) => {
  return (
    <section id="home" className="bg-gradient-to-br from-primary-50 to-white py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.h1 
            className="text-4xl md:text-6xl font-display font-bold text-gray-900 mb-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            AI Signature Generator -{' '}
            <span className="text-primary-600">Create Professional Signatures Online</span>
          </motion.h1>
          
          <motion.p 
            className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Generate handwritten signature designs with AI. Custom signature maker for business logos, 
            professional documents, and personal branding. Download in PNG, JPG & SVG formats instantly.
          </motion.p>

          <motion.button
            onClick={onGenerateClick}
            className="bg-primary-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-primary-700 transition-colors shadow-lg hover:shadow-xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Generate My Signature
          </motion.button>

          <motion.div 
            className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <SafeIcon icon={FiCheck} className="text-2xl text-green-500" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">AI-Generated Handwritten Signatures</h3>
              <p className="text-gray-600">Professional signature maker with realistic pen-stroke variation and natural handwriting flow</p>
            </div>

            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <SafeIcon icon={FiZap} className="text-2xl text-primary-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Custom Signature Design Styles</h3>
              <p className="text-gray-600">Create signature logos in elegant, modern, or executive styles for business branding</p>
            </div>

            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <SafeIcon icon={FiDownload} className="text-2xl text-orange-500" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Professional Logo File Formats</h3>
              <p className="text-gray-600">Download signature designs in JPG, PNG & SVG for business logos and documents</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Hero